import { ChangeDetectorRef, Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiLoaderService } from '../services/api-loader.service';

@Component({
    selector: 'api-loader',
    templateUrl: './api-loader.component.html',
    styleUrls: ['./api-loader.component.scss']
})
export class ApiLoaderComponent {
    show = false;
    private subscription: Subscription;
    isDarkMode: boolean = false;

    constructor(private loaderService: ApiLoaderService, private _changeDetectorRef: ChangeDetectorRef)
    {
        this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) =>
        {
            this.show = state.show;
            this._changeDetectorRef.detectChanges();
        });
    }

    ngOnInit()
    {
    }

    ngOnDestroy()
    {
        this.subscription.unsubscribe();
    }
}

export interface LoaderState {
    show: boolean;
}
